<template>
    <div v-if="users.length > 0">
       <div class="row py-2">
          <div v-for="(user, index) in users" :key="index" class="col-2 p-0">
            <span class="badge rounded-pill bg-danger py-2" style="cursor:pointer;" @click="addUser(user)">
                {{ user.text }}
                <i class="fas fa-user-plus"></i>
            </span>
          </div>
      </div>
    </div>
</template>
<script>
export default {
    props: {
        users: {
            type: Array,
            default: null,
        },
    },
    methods: {
        addUser(user) {
            this.$emit('show-add-user-modal', user);
        }
    },
};
</script>